import React, { Component } from 'react';
import {Grid } from 'semantic-ui-react';

import BasicSectionLayout from './SectionLayout';
import SectionHeaderLayout from './SectionHeaderLayout';
import ModalGalleyLayout from './ModalGalleryLayout';

import { bothSection } from './imagesSections';

class FirstSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlider: 'sliderone'
    }
    this.changeSlide = this.changeSlide.bind(this);
    this.intervalID = null;
    this.classes = ['sliderone', 'slidertwo'];
  }

  changeSlide() {
    if ( this.state.currentSlider === 'sliderone') {
      this.setState({currentSlider: 'slidertwo'});
      return;
    }
    this.setState({currentSlider: 'sliderone'});
  }
  
  componentDidMount() {
   // this.intervalID = window.setInterval(this.changeSlide, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID)
  }

  render() {
    return (
      <BasicSectionLayout sectionClasse={`first__section ${this.state.currentSlider}`} fluide={true}>
          <Grid.Column width={12} className="slider__grid">
  
            <div className="first__wrapper">
  
              <SectionHeaderLayout myhr={false} 
                headerclass="first__title"
                title="FIPI"
              >
                <p className="first__text">
                  Development through education...
                </p>
              </SectionHeaderLayout>
  
              <ModalGalleyLayout images={bothSection} 
                buttonTitle="explore the gallery"
                buttonClass="btnClass btnBackground"
              />
              
            </div>
  
          </Grid.Column>
      </BasicSectionLayout>
    )
  }

};

export default FirstSection;